<template>
    <div class="notificacion-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="95%" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                            <v-flex sm12 class="text-xs-center">
                                <v-fade-transition>
                                    <v-chip small dark label v-if="getGestorExpression">{{
                                        getGestorExpression
                                    }}</v-chip>
                                </v-fade-transition>
                            </v-flex>
                            <v-form ref="notificacionForm" v-model="validNotificacion">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="notificacionItem.nombre"
                                                label="Nombre"
                                                :rules="nombreRules"
                                                :error-messages="nombreErrors"
                                                @keydown="nombreErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-textarea
                                                v-model="notificacionItem.descripcion"
                                                label="Descripción"
                                                rows="3"
                                                :rules="descripcionRules"
                                                :error-messages="descripcionErrors"
                                                @keydown="descripcionErrors = []"
                                            >
                                            </v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6 pb-0>
                                            <v-autocomplete
                                                v-model="notificacionItem.tipo_id"
                                                :items="TIPOS_NOTIFICACION"
                                                label="Tipo de notificacion"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="tipo_idRules"
                                                :error-messages="tipo_idErrors"
                                                @blur="tipo_idErrors = []"
                                                return-object
                                                append-outer-icon="add"
                                                @click:append-outer="showTipoNotificacion = true"
                                                @change="updateCampos(notificacionItem.tipo_id.tableFields)"
                                            >
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{
                                                            getCategoriaValue(data.item)
                                                        }}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>
                                                <template v-slot:selection="data">
                                                    {{ getCategoriaValue(data.item) }}
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 sm3 pb-0>
                                            <v-select
                                                v-model="notificacionItem.op_relacion"
                                                :items="operadoresRelacion"
                                                label="Operador"
                                                :rules="op_relacionRules"
                                                :error-messages="op_relacionErrors"
                                                @blur="op_relacionErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm3 pb-0>
                                            <v-text-field
                                                v-model="notificacionItem.valor_relacion"
                                                label="Valor"
                                                type="number"
                                                min="0"
                                                :rules="valor_relacionRules"
                                                :error-messages="valor_relacionErrors"
                                                @blur="valor_relacionErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>

                            <v-form ref="condicionesForm" v-model="validCondicionesForm">
                                <v-container fluid grid-list-xl>
                                    <template v-for="index of condicionesCant">
                                        <v-fade-transition :key="index">
                                            <v-flex sm12 :key="index">
                                                <v-layout align-center wrap>
                                                    <v-flex xs12 sm3 py-0 v-if="index !== 1">
                                                        <v-select
                                                            v-model="condicionesValues[index - 1].op_logico"
                                                            :items="operadoresLogico"
                                                            label="Operador lógico"
                                                            :rules="op_logicoRules"
                                                            :error-messages="op_logicoErrors"
                                                            @blur="op_logicoErrors = []"
                                                        >
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 py-0>
                                                        <v-autocomplete
                                                            v-model="condicionesValues[index - 1].campos"
                                                            :items="camposValues"
                                                            hide-selected
                                                            label="Campo"
                                                            multiple
                                                            persistent-hint
                                                            small-chips
                                                            item-value="value"
                                                            :rules="[camposRules, camposStructureRule(index - 1)]"
                                                            :error-messages="camposErrors"
                                                            @change="camposErrors = []"
                                                            style="font-size: 12px"
                                                        >
                                                            <v-tooltip bottom slot="prepend">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon small v-on="on">fa-question</v-icon>
                                                                </template>
                                                                <span
                                                                    >Puede especificar un campo o alguna combinación de
                                                                    <br />operaciones para estos. Ej:
                                                                    campo1-campo2*campo3</span
                                                                >
                                                            </v-tooltip>
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm2 py-0>
                                                        <v-select
                                                            v-model="condicionesValues[index - 1].op_condicion"
                                                            :items="operadoresCondicion"
                                                            label="Operador"
                                                            :rules="op_condicionRules"
                                                            :error-messages="op_relacionErrors"
                                                            @blur="op_relacionErrors = []"
                                                        >
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm2 py-0>
                                                        <v-text-field
                                                            v-model="condicionesValues[index - 1].valor"
                                                            label="Valor"
                                                            :rules="valor_relacionRules"
                                                            :error-messages="valor_relacionErrors"
                                                            @change="valor_relacionErrors = []"
                                                        >
                                                            <v-tooltip bottom slot="prepend">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon small v-on="on">fa-question</v-icon>
                                                                </template>
                                                                <span
                                                                    >Para diferenciar un valor numérico de otro tipo
                                                                    <br />texto, encierre el texto entre ' '. Ej:
                                                                    'nombre'</span
                                                                >
                                                            </v-tooltip>
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm1 py-0>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon
                                                                    small
                                                                    icon
                                                                    flat
                                                                    color="red"
                                                                    v-on="on"
                                                                    @click="deleteConditionValue(index)"
                                                                    >fa-minus</v-icon
                                                                >
                                                            </template>
                                                            <span>Eliminar condición</span>
                                                        </v-tooltip>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-fade-transition>
                                    </template>

                                    <v-flex xs12 sm3>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="success lighten-1"
                                                    fab
                                                    small
                                                    :disabled="!validCondicionesForm || !validNotificacion"
                                                    @click="addCondicion()"
                                                    style="height: 30px; width: 30px"
                                                    class="ml-2"
                                                >
                                                    <v-icon small color="white" v-on="on">fa-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Agregar condición</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <tipo-notificacion-form
            v-if="showTipoNotificacion"
            form-title="Nuevo Tipo de notificacion"
            @formCanceled="showTipoNotificacion = false"
        ></tipo-notificacion-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const TipoNotificacionForm = () => import("@/components/notificacion/tipo-notificacion-form")
export default {
    components: { TipoNotificacionForm },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validNotificacion: false,
            notificacionItem: {
                tipo_id: null,
                nombre: "",
                descripcion: "",
                op_relacion: null,
                valor_relacion: null,
                condicion: null
            },

            dateFecha_cumplimiento: new Date().toISOString().substr(0, 10),
            menuFechaCumplimiento: false,

            //vista para gestionar los tipos de notificacion
            showTipoNotificacion: false,

            //saber si se cargaron todos los datos necesarios para seleccionar
            showErrorDataLoadedAlert: false,

            //alert errores de validacion
            showErrorAlert: false,

            //validaciones
            tipo_idRules: [v => !!v || "Debe seleccionar un tipo de notificación"],
            tipo_idErrors: [],
            nombreRules: [
                v => !!v || "Debe proporcionar un nombre",
                v => v.length <= 255 || "El nombre solo puede contener 255 caracteres"
            ],
            nombreErrors: [],
            descripcionRules: [v => v.length <= 255 || "La descripción solo puede contener 255 caracteres"],
            descripcionErrors: [],
            op_relacionRules: [v => !!v || "Debe seleccionar un operador para la relación"],
            op_relacionErrors: [],
            valor_relacionRules: [v => !!v || "Debe proporcionar un valor para la relación"],
            valor_relacionErrors: [],
            condicionErrors: [],

            //operadores de relacion
            operadoresRelacion: [
                { text: "<", value: "<" },
                { text: ">", value: ">" },
                { text: "<=", value: "<=" },
                { text: ">=", value: ">=" },
                { text: "=", value: "==" },
                { text: "<>", value: "<>" }
            ],

            //operadores de condicion
            operadoresCondicion: [
                { text: "<", value: "<" },
                { text: ">", value: ">" },
                { text: "<=", value: "<=" },
                { text: ">=", value: ">=" },
                { text: "<>", value: "<>" },
                { text: "=", value: "=" },
                { text: "LIKE", value: "LIKE" }
            ],

            //operadores logico
            operadoresLogico: [{ text: "AND", value: "AND" }, { text: "OR", value: "OR" }],

            //valores para los campos
            camposValues: [],

            //datos de las condiciones
            condicionesCant: 0,
            condicionesValues: [{ op_logico: null, campos: [], op_condicion: null, valor: null }],
            validCondicionesForm: false,

            //validaciones de las condiciones
            op_logicoRules: [v => !!v || "Debe seleccionar un operador para la condición"],
            op_logicoErrors: [],
            camposRules: v => !!v.length || "Debe proporcionar el campo para condición",
            camposErrors: [],
            op_condicionRules: [v => !!v || "Debe seleccionar un operador para la condición"],
            op_condicionErrors: [],
            valorRules: [v => !!v || "Debe proporcionar un valor para la condición"],
            valorErrors: []
        }
    },
    computed: {
        ...mapGetters(["TIPOS_NOTIFICACION", "BD_TABLES"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validNotificacion || !this.validCondicionesForm
        },

        getGestorExpression() {
            let relacion = ""
            let condicion = ""
            if (
                this.notificacionItem.tipo_id &&
                this.notificacionItem.op_relacion &&
                this.notificacionItem.valor_relacion
            ) {
                relacion = `CANTIDAD (${this.getCategoriaValue(this.notificacionItem.tipo_id)}) ${
                    this.notificacionItem.op_relacion
                } ${this.notificacionItem.valor_relacion}`

                this.notificacionItem.condicion = this.condicionesConcat

                if (this.notificacionItem.condicion) {
                    condicion += ` DONDE `
                    let condicionesList = this.notificacionItem.condicion.split(" ")
                    condicionesList.unshift(".")
                    for (let i = 0; i < condicionesList.length / 4; i++) {
                        if (i === 0) {
                            condicion += `(${this.formatStructure(condicionesList[4 * i + 1])} ${
                                condicionesList[4 * i + 2]
                            } ${condicionesList[4 * i + 3]}`
                        } else {
                            condicion += ` ${condicionesList[4 * i].toUpperCase()} ${this.formatStructure(
                                condicionesList[4 * i + 1]
                            )} ${condicionesList[4 * i + 2]} ${condicionesList[4 * i + 3]}`
                        }
                    }
                    condicion += `)`
                }
            }
            return relacion + condicion
        },

        condicionesConcat() {
            if (this.condicionesCant) {
                let condionesConcat = ""
                if (this.validCondicionesForm) {
                    this.condicionesValues.forEach((el, index) => {
                        if (index !== this.condicionesValues.length - 1) {
                            if (index === 0) {
                                condionesConcat += `${el.campos} ${el.op_condicion} ${el.valor}`
                            } else {
                                condionesConcat += ` ${el.op_logico} ${el.campos} ${el.op_condicion} ${el.valor}`
                            }
                        }
                    })
                    return condionesConcat
                } else {
                    this.condicionesValues.forEach((el, index) => {
                        if (
                            index !== this.condicionesValues.length - 1 &&
                            index !== this.condicionesValues.length - 2
                        ) {
                            if (index === 0) {
                                condionesConcat += `${el.campos} ${el.op_condicion} ${el.valor}`
                            } else {
                                condionesConcat += ` ${el.op_logico} ${el.campos} ${el.op_condicion} ${el.valor}`
                            }
                        }
                    })
                    return condionesConcat
                }
            }
            return ""
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.notificacionForm.validate()

            if (this.validNotificacion) {
                let notificacion = {
                    user_id: this.$store.getters.CURRENT_USER.id,
                    tipo_id: this.notificacionItem.tipo_id.id,
                    nombre: this.notificacionItem.nombre,
                    descripcion: this.notificacionItem.descripcion,
                    op_relacion: this.notificacionItem.op_relacion,
                    valor_relacion: this.notificacionItem.valor_relacion,
                    condicion: this.notificacionItem.condicion ? this.notificacionItem.condicion : ""
                }

                if (!this.isNewRecord) {
                    notificacion.id = this.notificacionItem.id
                }

                this.$store
                    .dispatch(this.isNewRecord ? "ADD_GESTOR_NOTIFICACION" : "UPDATE_GESTOR_NOTIFICACION", notificacion)
                    .then(result => {
                        if (!result) {
                            //no hay coneccion con el servidor
                            this.loading = false
                        }
                        if (result === null || result.status === 404 || result.status === 500) {
                            //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                            this.$emit("formCanceled")
                        } else {
                            // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                            let { data, status } = result
                            if (status === 422) {
                                data.forEach(error => {
                                    if (error.field === "tipo_id") {
                                        this.tipo_idErrors.push(error.message)
                                    }
                                    if (error.field === "op_relacion") {
                                        this.op_relacionErrors.push(error.message)
                                    }
                                    if (error.field === "valor_relacion") {
                                        this.valor_relacionErrors.push(error.message)
                                    }
                                    if (error.field === "condicion") {
                                        this.condicionErrors.push(error.message)
                                    }
                                    if (error.field === "descripcion") {
                                        this.descripcionErrors.push(error.message)
                                    }
                                    if (error.field === "nombre") {
                                        this.nombreErrors.push(error.message)
                                    }
                                })
                            }
                        }
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        getCategoriaValue(item) {
            if (item && item.categoria) {
                return Util.getNotificationCategorie(null, item.categoria, this.BD_TABLES)
            } else return " "
        },

        addCondicion() {
            this.condicionesValues.push({ op_logico: null, campos: [], op_condicion: null, valor: null })
            this.condicionesCant++
        },

        deleteConditionValue(index) {
            this.condicionesValues.splice(index, 1)
            this.condicionesCant--
        },

        camposStructureRule(index) {
            if (this.condicionesValues[index].campos.length) {
                return (
                    this.checkStructure(this.condicionesValues[index].campos) ||
                    "La estructura de los campos no es correcta"
                )
            } else return true
        },

        checkStructure(value) {
            let operators = ["+", "-", "*", "/"]
            let ret = true
            value.forEach((el, elIndex) => {
                if (elIndex % 2 === 0) {
                    if (operators.includes(el)) {
                        ret = false
                    }
                } else {
                    if (!operators.includes(el)) {
                        ret = false
                    }
                }
            })
            if (operators.includes(value[value.length - 1])) {
                ret = false
            }
            return ret
        },

        formatStructure(valor) {
            return valor.replace(new RegExp(",", "g"), " ")
        },

        updateCampos(fields) {
            this.camposValues = []
            if (this.notificacionItem.tipo_id && fields) {
                fields.forEach(el => this.camposValues.push({ text: el, value: el }))
            }
            this.camposValues.push(
                { text: "-", value: "-" },
                { text: "+", value: "+" },
                { text: "*", value: "*" },
                { text: "/", value: "/" }
            )
        }
    },

    created() {
        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.notificacionItem = Object.assign({}, this.initialItem)
            this.notificacionItem.tipo_id = this.initialItem.tipo

            if (this.initialItem.condicion) {
                this.updateCampos(this.notificacionItem.tipo_id.tableFields)

                let condicionesList = this.initialItem.condicion.split(" ")
                condicionesList.unshift(".")
                this.condicionesValues = []
                for (let i = 0; i < condicionesList.length / 4; i++) {
                    this.condicionesCant++
                    if (i === 0) {
                        this.condicionesValues.push({
                            op_logico: null,
                            campos: condicionesList[4 * i + 1].split(","),
                            op_condicion: condicionesList[4 * i + 2],
                            valor: condicionesList[4 * i + 3]
                        })
                    } else {
                        this.condicionesValues.push({
                            op_logico: condicionesList[4 * i],
                            campos: condicionesList[4 * i + 1].split(","),
                            op_condicion: condicionesList[4 * i + 2],
                            valor: condicionesList[4 * i + 3]
                        })
                    }
                }
                this.condicionesValues.push({ op_logico: null, campos: [], op_condicion: null, valor: null })
            }
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_TIPOS_NOTIFICACION").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
    }
}
</script>
